import { render, staticRenderFns } from "./NotActive.vue?vue&type=template&id=7280ff5d&scoped=true"
import script from "./NotActive.vue?vue&type=script&lang=js"
export * from "./NotActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280ff5d",
  null
  
)

export default component.exports